export default [
    {
        name: "GitHub",
        link: "https://github.com/Higao00",
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/GitHub.svg",
        qrcode: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/qr-codes/qrcode-github.png",
        type: "social",
        color: "#adadadeb",
    },
    {
        name: "Linkedin",
        link: "https://www.linkedin.com/in/higor-henrique-89105a187",
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/LinkedIn.svg",
        qrcode: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/qr-codes/qrcode-linkedin.png",
        type: "social",
        color: "#0a66c2",
    },
    {
        name: "Instagram",
        link: "https://www.instagram.com/higaofreitas",
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/Instagram.svg",
        qrcode: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/qr-codes/qrcode-instagram.png",
        type: "social",
        color: "#c44564",
    },

    {
        name: "Outlook",
        link: "freitashigor@hotmail.com",
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/Outlook.svg",
        qrcode: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/qr-codes/qrcode-outlook.png",
        type: "email",
        color: "#016bbb",
    },
    {
        name: "Gmail",
        link: "freitashigor16@gmail.com",
        logo: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/svg-icons/Gmail.svg",
        qrcode: "https://zurke-innovation.s3.us-east-1.amazonaws.com/portfolio/images/qr-codes/qrcode-gmail.png",
        type: "email",
        color: "#fbbc04",
    },
]
